import { FaIcon, ThemeTokens } from '@acp/core-ui';
import {
    Button, Menu, MenuButton, MenuList, Text,
} from '@chakra-ui/react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';

export function NavigationMenu({
    label,
    children,
}: {
    label: string;
    children: React.ReactNode;
}) {
    return (
        <Menu>
            <MenuButton
                as={Button}
                variant="link"
                size="sm"
                color="black"
                px={0}
                h="100%"
                position="relative"
                rounded="none"
                _active={{
                    color: 'black',
                    _before: {
                        content: '""',
                        h: '2px',
                        position: 'absolute',
                        w: '100%',
                        bgColor: ThemeTokens.AppNavigation.accentColor,
                        bottom: 0,
                    },
                }}
                _hover={{
                    color: 'black',
                    _before: {
                        content: '""',
                        h: '2px',
                        position: 'absolute',
                        w: '100%',
                        bgColor: ThemeTokens.AppNavigation.accentColor,
                        bottom: 0,
                    },
                }}
                fontWeight={400}
                rightIcon={(
                    <FaIcon icon={faChevronDown} size="xs" />
                )}
            >
                <Text fontSize="sm" _hover={{ bgColor: 'red' }} fontWeight="bold" maxW="fit-content">
                    {label}
                </Text>
            </MenuButton>
            <MenuList>{children}</MenuList>
        </Menu>
    );
}
